import { useState } from 'react';
import { faqItems } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于免费韩漫大全的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}